import { Box, Button, CircularProgress, Divider, Modal, Typography, Link as MuiLink, IconButton, Grid } from "@mui/material";
import { CONTATTI, ROOT } from "../../global/urlMapping";
import { useSelector } from "react-redux";
import { ERRORE_ASR, ERRORE_BLOCKING, ERRORE_CAMPAGNA_INATTIVA, ERRORE_CHECK_SCREENING, ERRORE_CUSTOM, ERRORE_DATI_ERRATI, ERRORE_GENERICO_API, ERRORE_GENERICO_POSTLOGIN, ERRORE_PAZIENTE_NON_TROVATO, ERRORE_SESSION_EXPIRED, ERRORE_UNAUTHORIZED, ERRORE_UNEXPECTED, LOADING, OPERATION_ERROR, } from "../../global/messaggioLabels";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { resetMessaggioStateAction } from "../../modules/messaggio/actions";
import { ErrorOutlineRounded } from "@mui/icons-material";
import { messaggioSelector } from "../../modules/messaggio/selectors";
import { resetStateWithoutAuthAction } from "../../modules/reset/actions";
import { IDLE, LOADING_BLOCKING } from "../../global/statusLabels";
import { logoutAction } from "../../modules/auth/actions";
import { generaLog } from "../../functions/utils";
import { switchBackToSaluteSimplex } from "../../global/messaggiErrore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

export const Messaggio = () => {
  const messaggio = useSelector(messaggioSelector);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let strutturaMessaggio;
  const logoutActions = () => {
    generaLog("Logout", "log");
    dispatch(resetStateWithoutAuthAction());
    dispatch(logoutAction());
    //handleLogout(authType);
  }

  switch (messaggio?.status) {
    case ERRORE_GENERICO_API:
      strutturaMessaggio = {
        titolo: "Servizi non disponibili",
        sottotitolo: "Errore di connessione",
        label: "INDIETRO",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          dispatch(resetMessaggioStateAction());
          navigate(ROOT);
        },
      };
      break;
    case ERRORE_ASR:
      strutturaMessaggio = {
        titolo: "Attenzione, verifica di essere un assistito di ASL3 o ASL5 e che i dati inseriti siano corretti",
        sottotitolo: 'Consultare l’area ', //customizzato con link 
        linkContatti: true,
        onClickContatti: () => {
          logoutActions();
          navigate(CONTATTI);
        },
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_PAZIENTE_NON_TROVATO:
      strutturaMessaggio = {
        titolo: messaggio?.value?.titolo,
        sottotitolo: 'Contattare il Servizio di Prevenzione della ASL o consultare l’area ', //customizzato con link 
        linkContatti: true,
        onClickContatti: () => {
          logoutActions();
          navigate(CONTATTI);
        },
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_DATI_ERRATI:
      strutturaMessaggio = {
        titolo:
          "Attenzione: i dati inseriti non corrispondono, si prega di verificare e rieseguire l'accesso.",
        sottotitolo: 'Se il problema persiste, contattare il Servizio di Anagrafe Sanitaria della ASL o consultare l’area ', //customizzato con link 
        linkContatti: true,
        onClickContatti: () => {
          logoutActions();
          navigate(CONTATTI);
        },
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_GENERICO_POSTLOGIN:
      strutturaMessaggio = {
        titolo: "Attenzione, si è verificato un errore imprevisto. Si prega di riprovare l'accesso più tardi.",
        sottotitolo: "Se il problema persiste, contattare il Servizio di Prevenzione della ASL o consultare l’area ", //customizzato con link
        linkContatti: true,
        onClickContatti: () => {
          logoutActions();
          navigate(CONTATTI);
        },
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_CHECK_SCREENING:
      strutturaMessaggio = {
        titolo: "Attenzione: non puoi partecipare a questa campagna di screening.",
        sottotitolo: "Contattare il Servizio di Prevenzione della ASL o consultare l’area ", //customizzato con link
        linkContatti: true,
        onClickContatti: () => {
          dispatch(resetMessaggioStateAction());
          navigate(CONTATTI);
        },
        label: "CONTINUA",
        primaryColor: "#2E7D32", //verde
        secondaryColor: "#E0F0DA", //verde chiaro
        onClickLink: () => {
          dispatch(resetMessaggioStateAction());
        },
      };
      break;
    case OPERATION_ERROR:
      strutturaMessaggio = {
        titolo: "Operazione fallita",
        sottotitolo: "Non è stata fatta alcuna modifica",
        label: "INDIETRO",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          dispatch(resetMessaggioStateAction());
          navigate(-1);
        },
      };
      break;
    case ERRORE_UNAUTHORIZED:
      strutturaMessaggio = {
        titolo: "Autenticazione fallita",
        sottotitolo: "Errore bloccante",
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_SESSION_EXPIRED:
      strutturaMessaggio = {
        titolo: "Sessione scaduta",
        sottotitolo: "Torna alla pagina principale",
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_UNEXPECTED:
      strutturaMessaggio = {
        titolo: "Servizi non disponibili",
        sottotitolo: "Errore inatteso",
        label: "INDIETRO",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          dispatch(resetMessaggioStateAction());
          navigate(-1);
        },
      };
      break;
    case ERRORE_BLOCKING:
      strutturaMessaggio = {
        titolo: "Servizi non disponibili",
        sottotitolo: "Errore bloccante",
        label: "ESCI",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          logoutActions();
        },
      };
      break;
    case ERRORE_CAMPAGNA_INATTIVA:
      strutturaMessaggio = {
        titolo:
          "Attenzione",
        sottotitolo:
          'La campagna non è ancora attiva nella tua Asl',
        label: "OK",
        primaryColor: "#D94B4B", //rosso
        secondaryColor: "#f7babb", //rosa scuro
        onClickLink: () => {
          dispatch(resetMessaggioStateAction())
        },
      };
      break;
    case ERRORE_CUSTOM://TODO
      strutturaMessaggio = {
        titolo: messaggio?.value?.titolo,
        sottotitolo: messaggio?.value?.sottotitolo,
        label: messaggio?.value?.label,
        primaryColor: messaggio?.value?.primaryColor,
        secondaryColor: messaggio?.value?.secondaryColor,
        onClickLink: messaggio?.value?.onClickLink,
      };
      break;
    default:
      strutturaMessaggio = {
        titolo: "",
        sottotitolo: "",
        label: "",
        primaryColor: "",
        secondaryColor: "",
        onClickLink: () => { },
        linkContatti: false,
        onClickContatti: () => { }
      };
  }

  return (
    <>
      {messaggio?.status !== LOADING && messaggio?.status !== LOADING_BLOCKING && messaggio?.status !== IDLE && (
        <Modal
          id="modal"
          open={true}
          disableAutoFocus
          sx={{ width: "100%", display: "flex" }}
        >
          <Box
            sx={{
              width: "380px",
              minHeight: "320px",
              display: "flex",
              flexDirection: "column",
              margin: "auto",
              backgroundColor: "white",
              borderRadius: "20px",
            }}
          >
            <Box
              sx={{
                minHeight: "150px",
                display: "flex",
                width: "100%",
                margin: "auto",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid container direction="row" spacing={2}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}>

                {/* Elemento all'inizio */}
                <Grid item xs={2} md={2} display="flex" justifyContent="flex-start" alignItems="flex-start">
                  {/* vuoto per questioni di centro */}
                </Grid>

                {/* Elemento al centro */}
                <Grid item xs={8} md={8} display="flex" justifyContent="center" alignItems="center">
                  <ErrorOutlineRounded
                    sx={{
                      color: strutturaMessaggio.primaryColor,
                      height: "110px",
                      width: "110px",
                    }}
                  />
                </Grid>

                {/* Elemento alla fine */}
                <Grid item xs={2} md={2} display="flex" justifyContent="flex-end" alignItems="flex-end">
                  <IconButton
                    className='cursorPointer'
                    disableRipple
                    onClick={() => {
                      dispatch(resetMessaggioStateAction());
                      strutturaMessaggio?.onClickLink();
                    }}
                    aria-label="chiudi avviso"
                    sx={{
                      '&:focus,&:hover': {
                        backgroundColor: strutturaMessaggio?.secondaryColor,
                      },
                      width: '35px',
                      height: '35px',
                    }}
                  >
                    <FontAwesomeIcon icon={faClose} size='1x' color={strutturaMessaggio?.primaryColor} />
                  </IconButton>
                </Grid>
              </Grid>
              <Typography
                sx={{
                  color: strutturaMessaggio.primaryColor,
                  wordWrap: "break-word",
                  margin: "auto",
                  fontWeight: "bold",
                  fontSize: "20px",
                  textAlign: "center",
                }}
              >
                {strutturaMessaggio.titolo}
              </Typography>
            </Box>
            <Divider
              variant="middle"
              sx={{
                width: "70%",
                margin: "10px auto",
              }}
            />
            {strutturaMessaggio?.linkContatti ?
              //TO DO
              <Box sx={{
                fontSize: "16px",
                //color: "black",
                fontWeight: "medium",
                textAlign: "center",
                margin: "auto",
                mx: "10px"
              }}>
                {strutturaMessaggio?.sottotitolo ?? `Consultare l'area `}
                <MuiLink className="change-cursor" sx={{ textDecoration: 'none', "&:hover": { textDecoration: 'underline' } }}
                  onClick={() => {
                    strutturaMessaggio?.onClickContatti();
                  }}>contatti</MuiLink>
                {` per avere maggiori informazioni.`}
              </Box>
              :
              <Typography
                sx={{
                  fontSize: "16px",
                  color: "black",
                  fontWeight: "medium",
                  textAlign: "center",
                  margin: "auto",
                  mx: "10px"
                }}
              >
                {strutturaMessaggio.sottotitolo}

              </Typography>
            }


            <Button
              disableRipple
              disableFocusRipple
              disableTouchRipple
              onClick={() => {
                dispatch(resetMessaggioStateAction());
                strutturaMessaggio.onClickLink();
                if (switchBackToSaluteSimplex(messaggio?.status) && window.ReactNativeWebView) {
                  window.ReactNativeWebView.postMessage("back")
                }
              }}
              sx={{
                display: "flex",
                margin: "auto",
                height: "40px",
                border: "3px solid " + strutturaMessaggio.primaryColor,
                borderRadius: "20px",
                "&:hover": {
                  backgroundColor: strutturaMessaggio.secondaryColor,
                },
                marginTop: "25px",
                marginBottom: "25px"
              }}
            >
              <Typography
                sx={{
                  textDecoration: "uppercase",
                  color: strutturaMessaggio.primaryColor,
                  fontSize: "16px",
                  fontWeight: "bold ",
                }}
              >
                {strutturaMessaggio.label}
              </Typography>
            </Button>
          </Box>
        </Modal>
      )}

      {
        (messaggio?.status === LOADING || messaggio?.status === LOADING_BLOCKING) && (
          <Modal
            open={true}
            disableAutoFocus
            sx={{ width: "100%", display: "flex" }}
          >
            <Box
              sx={{
                width: "365px",
                minHeight: "320px",
                display: "flex",
                flexDirection: "column",
                margin: "auto",
                backgroundColor: "white",
                borderRadius: "20px",
              }}
            >
              <Box
                sx={{
                  minHeight: "150px",
                  display: "flex",
                  width: "100%",
                  margin: "auto",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress
                  sx={{ color: "#005397 !important", margin: "auto" }}
                />
                <Typography
                  sx={{
                    color: "#005397",
                    wordWrap: "break-word",
                    margin: "auto",
                    fontWeight: "bold",
                    fontSize: "20px",
                  }}
                >
                  {"Caricamento in corso..."}
                </Typography>
              </Box>

              {messaggio?.status === LOADING && (
                <Button
                  disableRipple
                  disableFocusRipple
                  disableTouchRipple
                  component={Link}
                  onClick={() => {
                    dispatch(resetMessaggioStateAction());
                    navigate(-1);
                  }}
                  sx={{
                    width: "200px",
                    display: "flex",
                    margin: "auto",
                    height: "40px",
                    border: "3px solid #005397",
                    borderRadius: "20px",
                  }}
                >
                  <Typography
                    sx={{
                      textDecoration: "uppercase",
                      color: "#005397",
                      fontSize: "16px",
                      fontWeight: "bold ",
                    }}
                  >
                    {"TORNA INDIETRO"}
                  </Typography>
                </Button>
              )}
            </Box>
          </Modal>
        )}
    </>
  );
};
